var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverlayMobileLayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 161,
    viewBox: "0 0 148 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37545_42008)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 16,
    width: 60,
    height: 130,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 1.5,
    rx: 0.75,
    transform: "matrix(1 0 0 -1 69 23.5)",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 1.5,
    rx: 0.75,
    transform: "matrix(1 0 0 -1 80 23.5)",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 53,
    height: 60,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 92,
    width: 21,
    height: 7,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 125,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 125,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 125,
    width: 15,
    height: 15,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 101,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 104,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 107,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 110,
    width: 53,
    height: 2,
    rx: 1,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 115,
    width: 53,
    height: 8,
    rx: 2,
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 108.5,
    width: 19,
    height: 31,
    rx: 1.5,
    fill: "white",
    stroke: "#3C8EF9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37545_42008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.6641 121L61.3307 124L56.6641 127V121Z",
    fill: "#3C8EF9",
    stroke: "#3C8EF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37545_42008",
    x: 0,
    y: -5,
    width: 148,
    height: 218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.905882 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37545_42008"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37545_42008",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37545_42008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(55 120)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlayMobileLayout);
export default __webpack_public_path__ + "static/media/overlay-mobile-layout.c2ac3234a23a63c9e94c5c9346d72f7c.svg";
export { ForwardRef as ReactComponent };